import { Security } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import DefaultHome from "./pages";
import { sendUsageEvent } from "./components/utils/usageLogger";
import {
  initializeAppInsights,
  trackException,
  trackPageView,
} from "./components/utils/appInsights";
import "./App.css";

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    initializeAppInsights();

    const onWindowError = (event) => {
      const error = event.error || new Error(event.message || "Unknown window error");

      trackException(error, {
        source: "window_error",
        fileName: event.filename,
        lineNumber: event.lineno,
        columnNumber: event.colno,
      });
    };

    const onUnhandledRejection = (event) => {
      const reason = event.reason instanceof Error ? event.reason : new Error(String(event.reason));

      trackException(reason, {
        source: "unhandled_promise_rejection",
      });
    };

    window.addEventListener("error", onWindowError);
    window.addEventListener("unhandledrejection", onUnhandledRejection);

    return () => {
      window.removeEventListener("error", onWindowError);
      window.removeEventListener("unhandledrejection", onUnhandledRejection);
    };
  }, []);

  const oktaAuth = new OktaAuth({
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    issuer: process.env.REACT_APP_OKTA_ISSUER,
    redirectUri: `${window.location.origin}/callback`,
    scopes: ["openid", "profile", "email"],
    pkce: true,
    responseType: "id_token",
    disableHttpsCheck: true,
  });

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;

    trackPageView(path, {
      feature: "navigation",
      pathname: location.pathname,
      search: location.search,
    });

    sendUsageEvent("page_view", {
      feature: "navigation",
      path,
      metadata: {
        pathname: location.pathname,
        search: location.search,
      },
    });
  }, [location.pathname, location.search]);

  const restoreOriginalUri = (_oktaAuth, originalUri) => {
    navigate(toRelativeUrl(originalUri || "/", window.location.origin));
  };

  return (
    <div className="wrapper ">
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <DefaultHome />
      </Security>
    </div>
  );
}

export default App;
